<template>
<div class="mcontainer" v-show="indexShow==true">
  <div class="main__body">
    <News v-show="tabIndex==0 || tabIndex==1" ref="news" />
    <!-- <Asks v-show="tabIndex==1" ref="asks" /> -->
    <Me v-show="tabIndex==2" ref="me" />
    <Asks v-show="tabIndex==3" ref="Asks" />
  </div>
  <van-tabbar v-model="tabIndex" @change="tabChange">
    <van-tabbar-item :icon="item.icon" v-for="(item,index) in tab" :key="index">{{item.title}}</van-tabbar-item>
  </van-tabbar>
</div>
</template>
<script>
import {
  mapActions
} from 'vuex'
import News from "@/components/News";
import Asks from "@/components/Asks";
import Me from "@/components/Me";
export default {
  components: {
    News,
    Asks,
    Me
  },
  data() {
    return {
      tabIndex: 0,
      tab: [{
          title: '政策讯息',
          icon: 'comment'
        },
        {
          title: '流程介绍',
          icon: 'cluster'
        },
        {
          title: '加装申请',
          icon: 'smile'
        },
        {
          title: '咨询解答',
          icon: 'fire'
        }
      ],
      indexShow: false
    }
  },
  props: [],
  computed: {
    id() {
      return this.$route.query.id
    },
    type() {
      return this.$route.query.type
    }
  },
  watch: {},
  created() {
    let {
      type
    } = this
    if (typeof type == 'undefined') {
      this.tabIndex = 0
    } else {
      this.tabIndex = Number(type)
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    let {
      tabIndex
    } = this
    tabIndex = Number(tabIndex)
    let self = this
    if (tabIndex == 0) {
      this.checkAuth()
    } else {
      this.indexShow = true
      switch (tabIndex) {
        case 0:
          self.$refs.news.init(1)
          break;
        case 1:
          self.$refs.news.init(2)
          break;
        case 2:
          self.$refs.me.init()
          break;
        case 3:
          self.$refs.Asks.init()
          break;
      }
    }

  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll); //监听页面滚动事件
  },
  methods: {
    checkAuth() {
      let userInfo = this.$utils.getStorage('userInfo')
      if (userInfo == null) {
        let {
          id
        } = this
        if (typeof id != 'undefined') {
          this.getUserInfo(id)
        } else {
          let checkWeixin=this.$utils.isInWeixin()
          if(checkWeixin){
            let callBackUri = 'https://wb.jzlmwl.com/dianti/api/auth'
            let redirectUri = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx878d392f0f34cf1e&redirect_uri=' + callBackUri + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
            window.location.href = redirectUri
          }else{
            this.indexShow = true
            if (this.tabIndex == 0) {
              this.$refs.news.init(1)
            }
          }
        }
      } else {
        this.indexShow = true
        if (this.tabIndex == 0) {
          this.$refs.news.init(1)
        }
      }
    },
    async getUserInfo(id) {
      let posData = {
        data: {
          id
        }
      }
      let res = await this._getUserInfo(posData)
      if (res && res.code == 200) {
        this.$utils.setStorage('userInfo', res.data)
        window.location.href="https://wb.jzlmwl.com/dianti"
        // this.indexShow = true
        // if (this.tabIndex == 0) {
        //   this.$refs.news.init(1)
        // }
      }
    },
    handleScroll() {
      let self = this
      let {
        tabIndex
      } = self

      let bot = self.$utils.getScrollBot()
      if (bot < 150) {
        switch (tabIndex) {
          case 0:
            self.$refs.news.loadMore()
            break;
          case 1:
            self.$refs.news.loadMore()
            break;
          case 3:
            self.$refs.Asks.loadMore()
            break;
        }
      }
    },
    tabChange(index) {
      let self = this
      self.tabIndex = index
      switch (index) {
        case 0:
          self.$refs.news.init(1)
          break
        case 1:
          self.$refs.news.init(2)
          break
        case 2:
          self.$refs.me.init()
          break
        case 3:
          self.$refs.Asks.init()
          break
      }
    },
    ...mapActions('api', ['_getUserInfo'])
  }
}
</script>
<style lang="less" scoped>
.mcontainer {}
</style>
